module.exports = __webpack_public_path__ + "static/img/Siti Balqis-close.d9dc5c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/profile/closeup/Siti Balqis-close.jpg
// module id = bmir
// module chunks = 1